const normalizeUserId = userId =>
  typeof userId === 'string' ? userId.toLowerCase() : '';

export const getUserOptionLabel = user => {
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ');

  if (name && user?.email) {
    return `${name} (${user.email})`;
  }

  return name || user?.email || user?.id || '';
};

export const mapUsersToOptions = users =>
  (Array.isArray(users) ? users : [])
    .filter(user => user?.id)
    .map(user => ({
      value: normalizeUserId(user.id),
      label: getUserOptionLabel(user),
    }));

export const mapUserIdToOption = (
  userId,
  users,
  knownOption,
  unavailableUserLabel = 'Unavailable user',
) => {
  const optionsByUserId = new Map(
    [...mapUsersToOptions(users), ...(knownOption ? [knownOption] : [])]
      .filter(option => option?.value)
      .map(option => [normalizeUserId(option.value), option]),
  );

  const normalizedUserId = normalizeUserId(userId);
  if (!normalizedUserId) {
    return null;
  }

  return (
    optionsByUserId.get(normalizedUserId) || {
      value: normalizedUserId,
      label: unavailableUserLabel,
    }
  );
};

export const mapOptionToUserId = option =>
  normalizeUserId(option?.value) || null;

export const getItemsFromListResult = result => {
  if (!result?.ok) {
    return [];
  }

  if (Array.isArray(result.data?.data)) {
    return result.data.data;
  }

  return Array.isArray(result.data) ? result.data : [];
};

export const getItemsFromRequiredListResult = result => {
  if (!result?.ok) {
    const error = new Error('Required user directory could not be loaded');
    error.result = result;
    throw error;
  }

  return getItemsFromListResult(result);
};

export const shouldRefreshConfigAfterSaveError = result =>
  result?.statusCode === 400 || result?.statusCode === 409;

export const createDebouncedOptionsLoader = (fetchOptions, delay = 300) => {
  let timeoutId;
  let latestRequestId = 0;

  return (searchValue, callback) => {
    window.clearTimeout(timeoutId);
    latestRequestId += 1;
    const requestId = latestRequestId;
    timeoutId = window.setTimeout(async () => {
      let options = [];
      try {
        options = await fetchOptions((searchValue || '').trim());
      } catch {
        options = [];
      }
      // A newer search may have started while this fetch was in flight;
      // only the latest request may deliver options.
      if (requestId === latestRequestId) {
        callback(options);
      }
    }, delay);
  };
};
